/**
 * Die Direktive zum Einlesen der Perioden für die Timeline
 * @class directive_v3sPeriod
 * @memberOf v3sWbtPlayerApp:animation
 * @param {string} v3s-intervall  - Startzeit in Sekunden (TODO)
 * @example
 * Jetzt: <v3s-period v3s-intervall="1000"> ... </v3s-period>
 * Soll:  <v3s-period v3s-intervall="1"> ... </v3s-period>
 */
angular.module('v3sWbtPlayerApp').directive('v3sPeriod', ["v3sPeriodService", function (v3sPeriodService) {
    return {
        restrict: 'E',
        scope: {
            v3sIntervall: "@",
            v3sCondition: "@",
            v3sItem: "@"
        },
        controller: ["$scope", function ($scope) {

            $scope.period = {};
            $scope.period.actions = [];

            if (!!$scope.v3sCondition) {

               
                if (!$scope.v3sItem) { //TODO: Migration, altes Format

                    if ($scope.v3sCondition.indexOf("sco") == 0) {
                        $scope.period.items = "currentSco";
                    } else if ($scope.v3sCondition.indexOf("wbt") == 0) {
                        $scope.period.items = "wbt";
                    } else if ($scope.v3sCondition.indexOf("test") == 0 || $scope.v3sCondition.indexOf("lastTest") == 0) {
                        $scope.period.items = "test";
                    } else {
                        $scope.period.items = "currentPage";
                    }

                    if ($scope.v3sCondition.indexOf("NotCompletedAndPassed") > 0) {
                        $scope.period.conditions = "incompleteOrFailed";
                    } else if ($scope.v3sCondition.indexOf("CompletedAndPassed") > 0) {
                        $scope.period.conditions = "completed;passed";
                    } else if ($scope.v3sCondition.indexOf("NotCompleted") > 0) {
                        $scope.period.conditions = "incomplete";
                    } else if ($scope.v3sCondition.indexOf("Completed") > 0) {
                        $scope.period.conditions = "completed";
                    } else if ($scope.v3sCondition.indexOf("NotPassed") > 0) {
                        $scope.period.conditions = "failed";
                    } else if ($scope.v3sCondition.indexOf("Passed") > 0) {
                        $scope.period.conditions = "passed";
                    } else if ($scope.v3sCondition.indexOf("evaluationNotCorrect") >= 0) {
                        $scope.period.conditions = "lastFailed";
                    } else if ($scope.v3sCondition.indexOf("evaluationCorrect") >= 0) {
                        $scope.period.conditions = "lastPassed";
                    } else if ($scope.v3sCondition.indexOf("lastTestNotPassed") >= 0) {
                        $scope.period.conditions = "lastFailed";
                    } else if ($scope.v3sCondition.indexOf("lastTestPassed") >= 0) {
                        $scope.period.conditions = "lastPassed";
                    }

                } else {
                    $scope.period.items = $scope.v3sItem;
                    $scope.period.conditions = $scope.v3sCondition;
                }

            } else {
                $scope.period.intervall = parseFloat($scope.v3sIntervall) || 0;

                if(!!$scope.v3sIntervall && $scope.v3sIntervall.indexOf(".") == -1){ // 8.0 Format (in ms)
                    $scope.period.intervall /= 1000;
                }
            }

            /**
            * Fügt eine Aktion zu der Periode hinzu
            * @memberOf v3sWbtPlayerApp:animation.directive_v3sPeriod
            * @param {object} action  - Aktion
            */
            this.addAction = function (action) {
                $scope.period.actions.push(action);
            }
        }],
        link: function (scope) {
            v3sPeriodService.addPeriod(scope.period);
        }
    }
}]);
